import {deleteCookie, getCookie, setCookie} from "./utils/manage-cookie";
import {AppPlatform} from "./types/types";

// const debug = "DesktopApp"
const debug = false

export class DesktopApp {

    // browser cookie

    static set openLinksInDesktopAppCookie(value: boolean | undefined) {

        if (value === undefined) {
            deleteCookie('openLinksInDesktopApp')
            return
        }

        setCookie("openLinksInDesktopApp", value.toString(), 34560000)
    }

    static get openLinksInDesktopAppCookie(): boolean | undefined {
        const value = getCookie("openLinksInDesktopApp")

        if (value === undefined) {
            return undefined
        }

        return value.toLowerCase() === 'true'
    }

    static deleteOpenLinksInDesktopAppCookie() {
        deleteCookie('openLinksInDesktopApp')
    }


    // User Settings

    static setSuggestOpenLinksInDesktop(value: boolean | undefined):void {
        gd.user.settings.desktopApp.openLinksInDesktopApp = value;
        gd.user.settings.save()
    }

    // Check if we need to show open link growl....
    static get shouldSuggestOpenLinksInDesktopApp():boolean {

        // this.syncCookies()

        switch (gd.appPlatform) {

            case AppPlatform.BROWSER:

                if (!gd.user.settings.desktopApp.openLinksInDesktopApp) return false;

                if (DesktopApp.openLinksInDesktopAppCookie === undefined) {
                    return true
                }

                return false

            case AppPlatform.ELECTRON:

                if (gd.user.settings.desktopApp.openLinksInDesktopApp === undefined) return true;

                return false

            case AppPlatform.MOBILE:
                return false

        }

        return false
    }



}
